import BaseStore from './BaseStore';
import { observable, action, configure } from 'mobx';
import axios from 'axios';

import config from './Config';

configure({ enforceActions: 'observed' }) // don't allow state modifications outside actions

class ProjectModel {
	@observable id = null;
	@observable title = '';
	@observable description = '';
	@observable featureLayerURL = '';
	@observable vectorTileLayerURL = '';
	@observable extent = null;

	static properties = ['title', 'description', 'featureLayerURL', 'vectorTileLayerURL', 'extent'];

	constructor(props) {
		this.id = props.id || null;
		ProjectModel.properties.forEach( key => {
			this[key] = props[key];
		});
	}
}

class ProjectListStore extends BaseStore {
	uploadAction = config.apis.projects.uploadFile;

	loadImplementation(opt) {
		return axios.get(config.apis.projects.find, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			this.setItems(response.data);
			return response.data;
		});
	}

	fetchById(id) {
		return axios.get(config.apis.projects.findById(id), {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			return response.data;
		}).catch( (err) => {
			console.error(err);
			throw err;
		});
	}

	insertImplementation(values){
		return axios.post(config.apis.projects.create, values, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			return response.data;
		}).catch( (err) => {
			if (err.response && err.response.data && err.response.data.error){
				throw err.response.data.error;
			}
			throw err;
		});
	}

	updateImplementation(values){
		//we're patching, not really replacing the attributes.
		//see: https://loopback.io/doc/en/lb3/Exposing-models-over-REST.html
		return axios.patch(config.apis.projects.update(values.id), values, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			return response.data;
		}).catch( (err) => {
			console.error(err);
			throw err;
		});
	}

	deleteImplementation(id) {
		return axios.delete(config.apis.projects.delete(id), {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			return response.data;
		}).catch( (err) => {
			console.error(err);
			throw err;
		});
	}
}

export { ProjectModel, ProjectListStore };

